<div ngModelGroup="address">
    <!--First name && Last name-->
    @if (!hideFirstAndLastName) {
    <input-wrap class="w-12 m-t-5"
                [messages]="{required: 'Please enter first name' | translate}">
        <input class="input"
               type="text"
               name="firstname"
               cy-addressAddFname
               (blur)="onInputBlur()"
               autocomplete="given-name"
               [muiInput]="'First Name' | translate"
               [(ngModel)]="data.firstname"
               required>
    </input-wrap>
    <input-wrap class="w-12 m-t-5"
                [messages]="{required: 'Please enter last name' | translate}">
        <input class="input"
               type="text"
               name="lastname"
               (blur)="onInputBlur()"
               cy-addressAddLname
               autocomplete="family-name"
               [muiInput]="'Last name' | translate"
               [(ngModel)]="data.lastname"
               required>
    </input-wrap>
    }
    <!--Phone-->
    @if (!hidePhone) {
    <input-wrap class="w-12 m-t-5"
                [messages]="{required: 'Please enter telephone' | translate}"
                [attr.focus-msg]="phoneFocusMsg | translate">
        <input class="input"
               type="text"
               name="telephone"
               validatePattern="telephone"
               inputmode="numeric"
               (blur)="onInputBlur()"
               autocomplete="tel"
               cy-addressAddPhone
               [muiInput]="'Mobile number' | translate"
               [(ngModel)]="data.telephone"
               required>
    </input-wrap>
    }

    <!--Country-->
    <input-wrap class="w-12 m-t-5"
                [messages]="{required: 'Please select country' | translate}">
        <select class="select"
                name="country"
                cy-addressAddCountry
                [muiInput]="'Country' | translate"
                [(ngModel)]="data.country_id"
                autocomplete="country"
                (change)="onCountryChange()"
                required>
            @for (country of countries | orderBy: ['name'] | pushCountriesToFront; track $index) {
            @if (country.code !== 'divider') {
            <option [value]="country.code">{{country.name}}</option>
            }
            @if (country.code === 'divider') {
            <option [value]="undefined"
                    disabled="disabled">----------------</option>
            }
            }
        </select>
    </input-wrap>

    @if (searcher) {
    <div class="pos-relative m-t-5"
         (offClick)="searcher.clear()"
         [offClickOff]="!searcher.hints.length">
        <input-wrap class="pos-relative"
                    [ngClass]="{'is-busy': searcher.status.busy}">
            <input class="input"
                   type="text"
                   name="query"
                   autocomplete="off"
                   [muiInput]="'Search for your address' | translate"
                   [(ngModel)]="searcher.query"
                   (keydown.enter)="searcher.search()">
            @if (searcher.status.busy) {
            <span class="pos-absolute top-0 right-2 bottom-0 flex flex-middle flex-justify-center pe-none">
                <i class="icon-loading"></i>
            </span>
            }
            <div class="pos-relative">
                <div class="pos-absolute right-0 left-0 z-5 ng-hide dropdown-options bg-col-w"
                     role="listbox"
                     [attr.aria-hidden]="!searcher.hints.length"
                     [attr.tabindex]="searcher.hints.length ? 0 : -1"
                     [ngClass]="{'ng-hide': !searcher.hints.length}">
                    <ul class="dropdown-options-inner">
                        @for (hint of searcher.hints; track $index) {
                        <li class="flex flex-middle cursor-pointer no-wrap p-t-1 p-r-2 p-b-1 p-l-2 dropdown-option"
                            role="option"
                            (click)="searcher.search(hint)">
                            <span class="lh-1 dropdown-option-label">
                                <span class="block">{{hint.Text}}</span>
                                <span class="fs-4">{{hint.Description}}</span>
                            </span>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </input-wrap>
    </div>


    <input-wrap class="m-t-5 block left">
        <checkbox [name]="'address'"
                  [checked]="isFormVisible"
                  [(ngModel)]="searcher.isManual"
                  (checkedChange)="checkedChangeHandle($event)">
            <span class="p1">{{'Enter address manually' | translate}}</span>
        </checkbox>
    </input-wrap>
    }

    <div class="m-t"
         [ngClass]="{'ng-hide': !isFormVisible}">

        <!--Street Name-->
        <input-wrap class="w-12 m-t"
                    [messages]="{required: 'Please enter street' | translate}">
            <input class="input"
                   type="text"
                   name="street_1"
                   (blur)="onInputBlur()"
                   cy-addressAddFirstLine
                   [muiInput]="'Address line 1' | translate"
                   autocomplete="address-line1"
                   [(ngModel)]="data.street_1"
                   required>
        </input-wrap>

        <input-wrap class="w-12 m-t-5">
            <input class="input"
                   type="text"
                   name="street_2"
                   (blur)="onInputBlur()"
                   autocomplete="address-line2"
                   cy-addressAddSecondLine
                   [muiInput]="'Address line 2' | translate"
                   [(ngModel)]="data.street_2">
        </input-wrap>

        <!--Town-->
        <input-wrap class="w-12 m-t-5"
                    [messages]="{required: 'Please enter town / city' | translate}">
            <input class="input"
                   type="text"
                   name="city"
                   (blur)="onInputBlur()"
                   cy-addressAddCity
                   [muiInput]="'Town' | translate"
                   autocomplete="address-level1"
                   [(ngModel)]="data.city"
                   required>
        </input-wrap>

        <!--Region-->
        @if (!regions) {
        <input-wrap class="w-12 m-t-5"
                    [messages]="{required: 'Please enter region' | translate}">
            <input class="input"
                   type="text"
                   (blur)="onInputBlur()"
                   name="region"
                   cy-addressAddRegion
                   [muiInput]="'Regions' | translate"
                   autocomplete="address-level2"
                   [(ngModel)]="data.region"
                   [required]="regionRequired">
        </input-wrap>
        }
        @if (regions) {
        <input-wrap class="w-12 m-t-5"
                    [messages]="{required: 'Please enter region' | translate}">
            <select class="select"
                    name="region_id"
                    cy-addressAddRegionId
                    [muiInput]="'Regions' | translate"
                    [(ngModel)]="data.region_id"
                    [required]="regionRequired">
                <option value=""></option>
                @for (region of regions | orderBy: ['name']; track region.id) {
                <option [value]="region.id">{{region.name}}</option>
                }
            </select>
        </input-wrap>
        }

        <!--Post Code-->
        <input-wrap class="w-12 m-t-5"
                    [messages]="{required: 'Please enter postcode' | translate}">
            <input class="input"
                   type="text"
                   name="postcode"
                   cy-addressAddPostcode
                   autocomplete="postal-code"
                   [muiInput]="'Post Code' | translate"
                   [(ngModel)]="data.postcode"
                   (ngModelChange)="handlePostcodeChange()"
                   (blur)="handlePostcodeBlur()"
                   required>
        </input-wrap>
        @if(postcodeWarning$.value){
        <p class="col-62 m-t p2">{{postcodeWarning$.value}}</p>
        }

        <!--PID/DNI Number-->
        <ng-container *ifNotTradeStore>
            @if (isCountrySpain) {
            <input-wrap class="w-12 m-t-5"
                        [messages]="{required: 'Please enter PID/DNI Number' | translate}">
                <input class="input"
                       type="text"
                       name="dni"
                       cy-addressAddPostcode
                       [muiInput]="'PID/DNI Number' | translate"
                       [(ngModel)]="data.dni"
                       required>
            </input-wrap>
            }
        </ng-container>
    </div>
</div>
